import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';
import { toNumber } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import {
  ClaimsTeamConfig,
  ClaimsTeamConfigPayload,
  TeamPayload,
} from '@/modules/employer/components/Claims/ClaimsProcessors/ClaimsProcessors.types';

export const formatDataToPayload = (data: ClaimsTeamConfig): ClaimsTeamConfigPayload => ({
  name: data.name,
  assigned_organizations_ids: data?.assignedOrganizationIds ? data.assignedOrganizationIds : [],
  ...(data?.isGenericClaimsTeam
    ? {
        is_generic_claims_team: true,
        allowed_services: [],
      }
    : {
        allowed_services: data.allowedServices.map((id) => toNumber(id)),
        is_generic_claims_team: false,
      }),
});

const useCreateClaimsTeamQuery = (onSuccess?: () => void) => {
  const { mutateAsync, isLoading } = useMutation(
    (value: ClaimsTeamConfig) => api.post<TeamPayload>(API_URL.CLAIMS_TEAMS, formatDataToPayload(value)),
    {
      onSuccess: () => {
        onSuccess && onSuccess();
      },
    }
  );

  const handleSave = useCallback(
    async (value: ClaimsTeamConfig) => {
      const data = await mutateAsync(value as ClaimsTeamConfig);
      const justCreatedTeam = data?.data;
      return justCreatedTeam;
    },
    [mutateAsync]
  );

  return {
    isLoading,
    create: handleSave,
  };
};

export default useCreateClaimsTeamQuery;
